import './assets/app.css'

import { createApp, defineCustomElement } from 'vue'
import { createPinia } from 'pinia';
import { createSentryPiniaPlugin } from '@sentry/vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import * as Sentry from "@sentry/vue";
import PrimeVue from 'primevue/config';
import Ripple from 'primevue/ripple';
import App from './App.vue'
import router from './router'
import { BsThemePreset } from './themePreset';
import ThemeSelector from './components/ThemeSelector.vue';
import { registerServiceWorker } from '@/services/serviceWorker';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import FontAwesomeIcon from './fontawesome-icons';

const app = createApp(App)

/*
if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'development-https') {
  const originalConsoleLog = console.log;
  const protocol = import.meta.env.MODE === 'development-https' ? 'wss:' : 'ws:';
  const port = 3001;
  const ws = new WebSocket(`${protocol}//${window.location.hostname}:${port}`);

  console.log = function (...args) {
    originalConsoleLog.apply(console, args); // Keep browser logging
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(args));
    } else {
      ws.onopen = () => ws.send(JSON.stringify(args));
    }
  };

  const originalConsoleError = console.error;
  console.error = function (...args) {
    originalConsoleError.apply(console, args); // Keep browser logging
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'error', data: args }));
    } else {
      ws.onopen = () => ws.send(JSON.stringify({ type: 'error', data: args }));
    }
  };

  ws.onerror = (err) => console.error('WebSocket error:', err);
  ws.onclose = () => console.log('WebSocket closed');
}
*/

app.use(ToastService);
app.use(PrimeVue, {
    theme: {
        preset: BsThemePreset,
        options: {
            cssLayer: {
                name: 'primevue',
                order: 'tailwind-base, primevue, tailwind-utilities'
            },
            darkModeSelector: '.bs-dark'
        }
    }
});

Sentry.init({
  app,
  dsn: "https://a5c29bfe06f5a954c23948f8f0843836@o4505676547883008.ingest.us.sentry.io/4505744477716480",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    //Sentry.replayIntegration(),
  ],
  enabled: window.location.host.match(/^(.*)\.bookonthebrightside.com/) !== null,

  tracesSampleRate: 0.1,

  tracePropagationTargets: ["localhost", /^https:\/\/(.*)\.bookonthebrightside.com\/(rm4|RM4|gwt|brightside)/],

  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
});

app.use(router)
const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);
app.component('font-awesome-icon', FontAwesomeIcon);
const themeSelectorDefinition = defineCustomElement(ThemeSelector)
customElements.define('theme-selector', themeSelectorDefinition)

app.mount('#app')

registerServiceWorker();